// extracted by mini-css-extract-plugin
export default {"button":"MapButton_button__KQBLE","text":"MapButton_text__3Y3QQ"};